module.exports = __webpack_public_path__ + "static/media/logo_cs_header.78dfe00d.svg";